import React from 'react'
import { faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import laptop from '../../Assets/laptop.png'
import laptop1 from '../../Assets/laptop2.png'
import laptop2 from '../../Assets/laptop1.png'
import laptop3 from '../../Assets/laptop3.png'
import laptop4 from '../../Assets/laptop4.png'




export const Project = () => {
  return (
    <div className='flex flex-col gap-4 p-8 bg-blue-700 relative pt-16 h-full ' id='project'>
        <h2 className='text-white font-bold  text-4xl md:text-6xl absolute md:right-1/2 md:translate-x-1/2 z-10 bg-inherit md:p-4  px-3'>
            My Projects
        </h2>
        <div className='md:w-[4px] bg-white  md:h-full absolute left-1/2  '></div>
        <div className=' flex flex-col md:flex-row md:gap-[0px]  items-center md:mt-36 mt-32  relative '>
           <div className='md:w-1/2 group '> 
              <a href="#">
                <img src={laptop2} alt="" className='md:absolute top-0 z-10 group-hover:scale-110 duration-200 ease-in-out'/>
              </a>
              <div className='md:h-[3px] md:w-1/3 right-1/2 absolute bg-white'></div>
              <span className="-z-10  group-hover:z-0 text-white text-lg top-10 py-1 px-4 tracking-wider bg-sky-600  rounded-lg absolute group-hover:-top-10 left-[100px] after:content-[' '] after:w-4 after:h-4 after:bg-sky-600 after:rotate-45 after:absolute after:bg-inherit  after:-bottom-2 after:left-[32px] ">
                <a href="https://myntra-clone-shivam112.pages.dev/"  target="_blank" rel="noopener noreferrer">
                  Myntra <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
              </span> 
            </div>
           <div className='flex flex-col gap-4  text-white md:w-1/2 md:pl-8'>
            <h2 className='font-bold text-3xl'>Myntra Clone</h2>
            <span className='-mt-4'>(Shopping Website)</span>
            <p>
                <ul>
                    <li ><span className='md:text-2xl md:font-bold text-xl'>- </span>Developed a fully responsive e-commerce website replicating the UI/UX of Myntra using React.js.</li>
                    <li ><span className='md:text-2xl md:font-bold  text-xl'>- </span>Implemented Redux Toolkit for efficient state management and seamless cart updates. </li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Implemented API fetching for product data and enhanced performance using lazy loading.</li>
                </ul>
            </p>
            <ul className='flex flex-wrap gap-2'>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#HTML</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#CSS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#JavaScript</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#react.JS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#Redux</li>
            </ul>
           </div>
        </div>
        {/* {PRoject-2} */}
        <div className='  flex flex-col-reverse md:flex-row md:gap-[0px]  items-center md:mt-36 mt-14 relative '> 

           <div className='flex flex-col gap-4  text-white md:w-1/2 md:pl-8 '>
            <h2 className='font-bold text-3xl'>The Fit Club</h2>
            <span className='-mt-4'>(Fitness Website)</span>
            <p>
                <ul>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Developed a responsive and interactive landing page for a fictional fitness club using React.js.</li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Showcased a modern UI design aimed at promoting fitness services. </li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>The website includes sections like a hero banner, fitness programs, pricing plans, testimonials, and footer.</li>
                </ul>
            </p>
            <ul className='flex flex-wrap gap-2'>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#HTML</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#CSS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#JavaScript</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#react.JS</li>
            </ul>
           </div>
           <div className='md:w-1/2  group'> 
              <a href="#">
                <img src={laptop1} alt="" className=' md:absolute right-0 top-0 z-10 group-hover:scale-110 duration-200 ease-in-out'/>
              </a>
              <div className='md:h-[3px] md:w-1/3 left-1/2 absolute bg-white'></div>
              <span className=" -z-10  group-hover:z-0 w-max text-white text-lg top-10 py-1 px-4 tracking-wider bg-sky-600  rounded-lg absolute group-hover:-top-10 right-[60px] after:content-[' '] after:w-4 after:h-4 after:bg-sky-600 after:rotate-45 after:absolute after:bg-inherit  after:-bottom-2 after:left-[32px] ">
                <a href="https://fitclub-shivam.pages.dev/" target="_blank" rel="noopener noreferrer">
                  The Fit Club <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
              </span> 
            </div>
        </div>   
        {/* {project-3} */}
        <div className='  flex flex-col md:flex-row md:gap-[0px]  items-center md:mt-36 mt-14 relative '>
           <div className='md:w-1/2 group '> 
              <a href="#">
                <img src={laptop3} alt="" className='md:absolute top-0 z-50 group-hover:scale-110 duration-200 ease-in-out '/>
              </a>
              <div className='md:h-[3px] md:w-1/3 right-1/2 absolute bg-white'></div>
               <span className=" -z-10  group-hover:z-0 w-max items-center text-white text-[10px] md:font-bold md:text-lg f md:py-1  py-2 md:px-4 px-1 tracking-wider bg-sky-600  rounded-lg absolute group-hover:-top-10 top-10 left-[100px] md:left-[200px] after:content-[' '] after:w-4 after:h-4 after:bg-sky-600 after:rotate-45 after:absolute after:bg-inherit  after:-bottom-2 after:left-[32px] ">
                <a href="" target="_blank" rel="noopener noreferrer" >
                  Currency Converter <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
              </span> 
            </div>
           <div className='flex flex-col gap-4  text-white md:w-1/2 md:pl-8'>
           <h2 className='font-bold text-3xl'>Currency Converter</h2>
            <span className='-mt-4'>(Real-Time Currency Converter)</span>
            <p>
                <ul>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Created a Currency Converter using HTML, CSS, and JavaScript.</li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Integrated real-time exchange rate data using the Fetch API. </li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Implemented dropdowns for selecting currencies and a clean input form.</li>
                    <li ><span className='md:text-2xl md:font-bold text-xl '>- </span>Focused on API integration, DOM manipulation, and responsive UI.</li>
                </ul>
            </p>
            <ul className='flex flex-wrap gap-2'>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#HTML</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#CSS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#JavaScript</li>
                
            </ul>
           </div>
        </div>
        
        <div className='  flex flex-col-reverse md:flex-row md:gap-[0px]  items-center md:mt-36 mt-14 relative md:mb-14 '>

           <div className='flex flex-col gap-4  text-white md:w-1/2 md:pl-8'>
            <h2 className='font-bold text-3xl'>Portfolio</h2>
            <span className='-mt-4'>( My Portfolio Website)</span>
            <p>
                <ul>
                    <li className=' text-lg'><span className='text-2xl font-bold '>- </span>A personal portfolio website to showcase my skills, projects, and achievements. This project is designed to provide a seamless user experience and a clean, modern layout that reflects my abilities as a developer.</li>
                </ul>
            </p>
            <ul className='flex flex-wrap gap-2'>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#HTML</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#CSS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#JavaScript</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#react.JS</li>
                <li className='border-white border-[1px] rounded-3xl p-2 py-1 text-sm'>#Tailwind</li>

            </ul>
           </div>
           <div className='md:w-1/2  group'> 
              <a href="#">
                <img src={laptop4} alt="" className=' md:absolute right-0 top-0 z-10 group-hover:scale-110 duration-200 ease-in-out'/>
              </a>
              <div className='md:h-[3px] md:w-1/3 left-1/2 absolute bg-white'></div>
              <span className=" -z-10  group-hover:z-0 w-max text-white text-lg  py-1 px-4 tracking-wider bg-sky-600  rounded-lg absolute  top-10 group-hover:-top-10 right-[70px] after:content-[' '] after:w-4 after:h-4 after:rotate-45 after:absolute after:bg-inherit  after:-bottom-2 after:left-[32px] ">
                <a href="https://-shivam.pages.dev/" target="_blank" rel="noopener noreferrer">
                  Portfolio <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
              </span> 
            </div>
           
        </div>  
    </div>
    
  )
} 